import {CreateAssetInput} from "../codegen/graphql";

export enum KnownSpecs {
    PRODUCT_KNOWN = "PRODUCT_KNOWN",
    MANUFACTURER_KNOWN = "MANUFACTURER_KNOWN",
    DEFAULT = "DEFAULT",
}

export const buildAssetInputFromSpecs = (knownSpecs: KnownSpecs, values: { [p: string]: any }): CreateAssetInput => {
    switch (knownSpecs) {
        case KnownSpecs.PRODUCT_KNOWN:
            return {
                productNode: {
                    productNodeId: values.productNodeId ?? values.productId,
                    serialNumber: values.serialNumber,
                    dateOfManufacture: values.dateOfManufacture,
                },
            };

        case KnownSpecs.MANUFACTURER_KNOWN:
            return {
                manufacturer: {
                    manufacturerId: values.manufacturerId,
                    productCode: values.productCode,
                    productName: values.productName,
                    serialNumber: values.serialNumber,
                    dateOfManufacture: values.dateOfManufacture,
                },
            };

        case KnownSpecs.DEFAULT:
            return {
                default: {
                    manufacturerName: values.manufacturerName,
                    manufacturerDomain: values.manufacturerDomain,
                    productCode: values.productCode,
                    productName: values.productName,
                    serialNumber: values.serialNumber,
                    dateOfManufacture: values.dateOfManufacture,
                },
            };

        default:
            throw new Error("Unhandled knownSpecs case: " + knownSpecs);
    }
}
